// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"cC-z","smallCardRow":"dC-z","largeCardRow":"eC-z","productSearchRow":"fC-z","curatedRow":"gC-z"};